// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__12_3b","requiredAsterisk":"Info_requiredAsterisk__3WhMp"};